import React from "react";
import { Heart, Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { useFavorites } from "../../context/FavoritesContext";
import { useCart } from "../../context/CartContext";
import { useLanguage } from "../../context/LanguageContext";
import { FEATURES } from "../../config/features";

// Reusable action pair: favorite toggle + add to order request.
// `variety` must contain {id, name, image, category_label}.
// Client decision (27-oct): hidden from the public site while the flags are off.
export default function ProductActions({ variety, dense = false }) {
  const fav = useFavorites();
  const cart = useCart();
  const { t } = useLanguage();
  if (!FEATURES.favorites && !FEATURES.orderRequests) return null;
  const isFav = fav.isFavorite(variety.id);
  const inCart = cart.lines.some((l) => l.variety_id === variety.id);

  const onFav = (e) => {
    e?.stopPropagation();
    fav.toggle(variety);
    toast(isFav ? t("actions.removedFav") : t("actions.addedFav"));
  };

  const onAdd = (e) => {
    e?.stopPropagation();
    cart.addLine(variety);
    toast.success(t("actions.added"), { description: variety.name });
  };

  return (
    <div className={`flex ${dense ? "gap-2" : "gap-3"} items-center`}>
      {FEATURES.favorites && (
      <button
        type="button"
        onClick={onFav}
        aria-pressed={isFav}
        data-testid={`fav-toggle-${variety.id}`}
        className={`grid place-items-center h-10 w-10 border transition-colors ${
          isFav ? "bg-[#D92A47] text-[#F6F2EC] border-[#D92A47]" : "border-current hover:border-[#D92A47] hover:text-[#D92A47]"
        }`}
        aria-label={isFav ? t("actions.removeFav") : t("actions.addFav")}
      >
        <Heart size={16} fill={isFav ? "currentColor" : "none"} strokeWidth={1.6} />
      </button>
      )}
      {FEATURES.orderRequests && (
      <button
        type="button"
        onClick={onAdd}
        data-testid={`add-order-${variety.id}`}
        className={`inline-flex items-center gap-2 h-10 px-4 text-[11px] font-semibold uppercase tracking-[0.14em] transition-colors ${
          inCart ? "bg-[#C4A46B] text-black" : "bg-[#D92A47] text-[#F6F2EC] hover:bg-[#b71e3a]"
        }`}
      >
        {inCart ? <Check size={14} /> : <Plus size={14} />}
        {inCart ? t("actions.inRequest") : t("actions.add")}
      </button>
      )}
    </div>
  );
}
